<template>
  <div>
    <v-select
      v-model="medioPago"
      label="Medio Pago"
      :items="mediosPagos"
      item-text="nombre"
      return-object
      @change="change"
      :clearable="clearable"
    />
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: { clearable: { type: Boolean, default: false } },
  data() {
    return {
      medioPago: null,
      mediosPagos: [],
    };
  },
  mounted() {
    axios
      .get("/medioPago")
      .then((response) => {
        console.log(response);
        this.mediosPagos = response.data;
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          this.errorMessage = err.response.data;
        } else {
          this.errorMessage = "Error";
        }
      });
  },
  methods: {
    change() {
      this.$emit("change", this.medioPago);
    },
  },
};
</script>